import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Badge,
} from "reactstrap";
import {
  RiContactsLine,
  RiFileList3Line,
  RiStoreLine,
  RiUser3Line,
} from "react-icons/ri";

const InfoButtonWithModal = ({ data, id = "InfoButton" }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);

  const isVendor = data && "VendorName" in data;

  const SectionHeader = ({ icon: Icon, title }) => (
    <div className="d-flex align-items-center mb-3">
      <Icon className="text-primary me-2" size={20} />
      <h5 className="mb-0 fw-semibold text-primary">{title}</h5>
    </div>
  );

  const InfoItem = ({ label, value }) => (
    <div className="mb-2">
      <small className="text-muted text-uppercase">{label}</small>
      <div className="fw-medium text-dark">
        {value || <span className="text-muted">N/A</span>}
      </div>
    </div>
  );

  const renderContent = () => {
    if (!data) return null;

    if (isVendor) {
      return (
        <Row>
          <Col md={12}>
            <SectionHeader icon={RiStoreLine} title="Vendor Details" />
            <Row>
              <Col md={4}>
                <InfoItem label="Company Name" value={data.VendorName} />
              </Col>
              <Col md={4}>
                <InfoItem label="GSTIN" value={data.VendorGSTIN} />
              </Col>
              <Col md={4}>
                <InfoItem label="Contact Number" value={data.VendorMobile} />
              </Col>
              <Col md={12}>
                <InfoItem label="Address" value={data.VendorAddress} />
                <InfoItem label="Email" value={data.VendorEmail} />
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }

    return (
      <Row>
        {/* Voucher Section */}
        <Col md={12}>
          <SectionHeader icon={RiFileList3Line} title="Voucher Details" />
          <Row>
            <Col md={6}>
              <InfoItem label="Voucher Date" value={data.VoucherDate} />
            </Col>
            <Col md={6}>
              <InfoItem label="Voucher Number" value={data.VoucherNumber} />
            </Col>
          </Row>
        </Col>

        {/* Client Section */}
        <Col md={12} className="mt-4">
          <SectionHeader icon={RiUser3Line} title="Tender By" />
          <Row>
            <Col md={4}>
              <InfoItem label="Client Name" value={data.Name} />
            </Col>
            <Col md={4}>
              <InfoItem label="Client Code" value={data.Code} />
            </Col>
            <Col md={4}>
              <InfoItem label="GSTIN" value={data.GSTIN} />
            </Col>

            {data.ClientNumber && (
              <Col md={6}>
                <InfoItem label="Contact Number" value={data.ClientNumber} />
              </Col>
            )}
            {data.ClientEmail && (
              <Col md={6}>
                <InfoItem label="Email" value={data.ClientEmail} />
              </Col>
            )}
          </Row>
        </Col>

        {/* Contact Section */}
        <Col md={12} className="mt-4">
          <SectionHeader icon={RiContactsLine} title="Contact Information" />
          <Row>
            <Col md={4}>
              <InfoItem label="Contact Person" value={data.ContactPerson} />
            </Col>
            <Col md={4}>
              <InfoItem label="Designation" value={data.Designation} />
            </Col>
            <Col md={4}>
              <InfoItem label="Office Hours" value={data.OfficeHours} />
            </Col>
            <Col md={6}>
              <InfoItem label="Mobile" value={data.Number} />
            </Col>
            <Col md={6}>
              <InfoItem label="Contact Email" value={data.ClientContactEmail} />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <>
      <button
        type="button"
        className="btn-icon-hover p-1 border-0 bg-transparent"
        id={id}
        onClick={toggleModal}
      >
        <i className="ri-information-line text-primary fs-5"></i>
      </button>

      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        size="lg"
        className="modern-modal"
      >
        <ModalHeader toggle={toggleModal} className="border-0 pb-0">
          <h4 className="fw-bold text-dark">Detailed Information</h4>
        </ModalHeader>
        <ModalBody className="pt-1">
          <div className="modal-content-wrapper p-3">{renderContent()}</div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default InfoButtonWithModal;
